<template>
    <div class="md:grid md:grid-cols-12 md:gap-6">
        <div class="sm:col-span-12">
            <div class="mt-1">
                <FormLabel :value="$t('messages.order_matters')" for="order_matters" />
                <input
                    name="selected"
                    v-model="form.order_matters"
                    id="order_matters"
                    type="checkbox"
                    class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                />
            </div>
        </div>

        <template v-if="form.answers">
            <div class="sm:col-span-12" v-auto-animate>
                <div v-for="(answer, index) in form.answers" :key="`${index}_${form.correct_answer_index}`">
                    <div class="mt-1">
                        <div class="flex gap-2 justify-between items-center" v-auto-animate>
                            <FormInput
                                required
                                :id="`answer_${index}`"
                                v-model="answer.text"
                                :name="`answer_${index}`"
                                type="text"
                                maxlength="30"
                                class="mt-1 w-full"
                            />
                            <button
                                type="button"
                                @click="deleteOption(form.answers, index)"
                                v-if="form.answers.length > 2"
                                class="inline-flex items-center px-1.5 py-1.5 border border-transparent text-xs font-medium rounded text-gray-700 bg-gray-100 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                            >
                                <IconTrash class="trash w-4 h-4" />
                            </button>
                        </div>
                        <FormError :value="errors[`options.answers.${index}.text`]" class="mt-2" />
                    </div>
                </div>
            </div>

            <div v-show="form.answers.length < 8">
                <PlusButton @click="addOption()" />
            </div>
        </template>
    </div>
</template>
<script>
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import FormError from '@/components/Forms/FormError.vue';
import PlusButton from '@/components/Forms/PlusButton.vue';
import { IconTrash } from '@tabler/icons-vue';

export default {
    name: 'QuestionMultipleChoiceOptions',
    components: {
        FormLabel,
        FormInput,
        FormError,
        PlusButton,
        IconTrash,
    },
    props: {
        modelValue: {
            required: true,
        },
        errors: {
            required: true,
        },
    },
    emits: ['update:modelValue'],
    data() {
        return {
            form: this.modelValue,
        };
    },
    watch: {
        // form(newVal) {
        //     this.$emit('update:modelValue', newVal);
        // },
        form: {
            handler(newVal) {
                this.$emit('update:modelValue', newVal);
            },
            deep: true,
        },
    },
    methods: {
        deleteOption(answers, index) {
            answers.splice(index, 1);
        },
        addOption() {
            this.form.answers.push({ text: '' });
        },
    },
    mounted() {
        let defaultOptions = {
            order_matters: false,
            answers: [{ text: '' }, { text: '' }],
        };
        if (!this.form.hasOwnProperty('answers')) {
            Object.entries(defaultOptions).forEach((entry) => (this.form[entry[0]] = entry[1]));
        }
    },
};
</script>
